import type { MenuItem } from "./types";

// i18next-extract-mark-ns-start menu
// 键盘菜单配置
// Translation keys used in this file:
// t('keyboard.menu.userInfo')
// t('keyboard.menu.quickConfig')
// t('keyboard.menu.boardConfig')
// t('common.advancedConfig')
// t('keyboard.menu.lighting')
// t('keyboard.menu.trigger')
// t('keyboard.menu.changeKey')
// t('keyboard.menu.advancedKey')
// t('keyboard.menu.macro')
// t('keyboard.menu.performance')
// t('keyboard.menu.testCalibration')
// t('keyboard.menu.wallArt')
// t('keyboard.menu.other')
// t('mouse.menu.userInfo')
// t('mouse.menu.boardConfig')
// t('mouse.menu.changeKey')
// t('mouse.menu.dpiSetting')
// t('mouse.menu.performance')
// t('mouse.menu.macro')
// t('mouse.menu.parameter')
// t('mouse.menu.lighting')
// t('mouse.menu.other')

export const keyboardMenuData: MenuItem[] = [
  {
    key: "2",
    title: "",
    children: [
      {
        key: "2-1",
        title: "keyboard.menu.quickConfig",
        path: "quickConfig",
        icon: "quickconfig",
      },
    ],
  },
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-2",
        title: "keyboard.menu.trigger",
        path: "trigger",
        icon: "trigger",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-4",
        title: "keyboard.menu.advancedKey",
        path: "advancedKey",
        icon: "advancekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-6",
        title: "keyboard.menu.performance",
        path: "performance",
        icon: "parameter",
      },
      {
        key: "4-7",
        title: "keyboard.menu.testCalibration",
        path: "testCalibration",
        icon: "test",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];
export const keyboardMenuDataHuafenda: MenuItem[] = [
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-2",
        title: "keyboard.menu.trigger",
        path: "trigger",
        icon: "trigger",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-4",
        title: "keyboard.menu.advancedKey",
        path: "advancedKey",
        icon: "advancekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-6",
        title: "keyboard.menu.performance",
        path: "performance",
        icon: "parameter",
      },
      {
        key: "4-7",
        title: "keyboard.menu.testCalibration",
        path: "testCalibration",
        icon: "test",
      },
      {
        key: "4-10",
        title: "keyboard.menu.screen",
        path: "screen",
        icon: "screen",
      },
      {
        key: "4-9",
        title: "keyboard.menu.musicDance",
        path: "musicDance",
        icon: "music",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];
/** SDCX DK63 Machine：板载配置 + 灯光 / 改键 / 宏 / 其他（无性能 / 高级键等） */
export const keyboardMenuDataSdcx: MenuItem[] = [
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

/** 智慧无限 DK87：板载配置 + 灯光 / 改键 / 宏 / 性能 / 其他 */
export const keyboardMenuDataZhwx: MenuItem[] = [
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-6",
        title: "keyboard.menu.performance",
        path: "performance",
        icon: "parameter",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

export const keyboardMenuDataBeiying: MenuItem[] = [
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-4",
        title: "keyboard.menu.advancedKey",
        path: "advancedKey",
        icon: "advancekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-6",
        title: "keyboard.menu.performance",
        path: "performance",
        icon: "parameter",
      },
      {
        key: "4-9",
        title: "keyboard.menu.wallArt",
        path: "wallpaper",
        icon: "parameter",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

/** 容园机械轴（X87S 等）：板载 / 灯光 / 改键 / 快捷指令 / 高级键 / 性能 / 其他 */
export const keyboardMenuDataRongyuan: MenuItem[] = [
  {
    key: "3",
    title: "",
    line: true,
    children: [
      {
        key: "3-1",
        title: "keyboard.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "keyboard",
      },
    ],
  },
  {
    key: "4",
    title: "common.advancedConfig",
    children: [
      {
        key: "4-1",
        title: "keyboard.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "4-3",
        title: "keyboard.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "4-5",
        title: "keyboard.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "4-4",
        title: "keyboard.menu.advancedKey",
        path: "advancedKey",
        icon: "advancekey",
      },
      {
        key: "4-6",
        title: "keyboard.menu.performance",
        path: "performance",
        icon: "parameter",
      },
      {
        key: "4-8",
        title: "keyboard.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

// 鼠标菜单配置
export const mouseMenuDataJiangMeng: MenuItem[] = [
  {
    key: "2",
    title: "",
    line: true,
    children: [
      {
        key: "2-1",
        title: "mouse.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "mouse",
      },
    ],
  },
  {
    key: "3",
    title: "common.advancedConfig",
    children: [
      {
        key: "3-1",
        title: "mouse.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "3-2",
        title: "mouse.menu.dpiSetting",
        path: "dpiSetting",
        icon: "dpi",
      },
      {
        key: "3-3",
        title: "mouse.menu.triggerSetting",
        path: "triggerSetting",
        icon: "trigger",
      },
      {
        key: "3-4",
        title: "mouse.menu.performance",
        path: "performance",
        icon: "performance",
      },
      {
        key: "3-5",
        title: "mouse.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "3-6",
        title: "mouse.menu.parameter",
        path: "parameter",
        icon: "parameter",
      },
      {
        key: "3-7",
        title: "mouse.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "3-8",
        title: "mouse.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

/** 展立菜单：在匠盟基础上增加「动态灵敏」 */
export const mouseMenuDataZhanli: MenuItem[] = [
  {
    key: "2",
    title: "",
    line: true,
    children: [
      {
        key: "2-1",
        title: "mouse.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "mouse",
      },
    ],
  },
  {
    key: "3",
    title: "common.advancedConfig",
    children: [
      {
        key: "3-1",
        title: "mouse.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "3-2",
        title: "mouse.menu.dpiSetting",
        path: "dpiSetting",
        icon: "dpi",
      },
      {
        key: "3-3",
        title: "mouse.menu.dynamicSensitivity",
        path: "dynamicSensitivity",
        icon: "dynamic",
      },
      {
        key: "3-4",
        title: "mouse.menu.performance",
        path: "performance",
        icon: "performance",
      },
      {
        key: "3-5",
        title: "mouse.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "3-6",
        title: "mouse.menu.parameter",
        path: "parameter",
        icon: "parameter",
      },
      {
        key: "3-7",
        title: "mouse.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "3-8",
        title: "mouse.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

export const mouseMenuDataBeiying: MenuItem[] = [
  {
    key: "2",
    title: "",
    line: true,
    children: [
      {
        key: "2-1",
        title: "mouse.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "mouse",
      },
    ],
  },
  {
    key: "3",
    title: "common.advancedConfig",
    children: [
      {
        key: "3-1",
        title: "mouse.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "3-2",
        title: "mouse.menu.dpiSetting",
        path: "dpiSetting",
        icon: "dpi",
      },
      {
        key: "3-3",
        title: "mouse.menu.performance",
        path: "performance",
        icon: "performance",
      },
      {
        key: "3-4",
        title: "mouse.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "3-5",
        title: "mouse.menu.parameter",
        path: "parameter",
        icon: "parameter",
      },
      {
        key: "3-7",
        title: "mouse.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

export const mouseMenuDataFreq: MenuItem[] = [
  {
    key: "2",
    title: "",
    line: true,
    children: [
      {
        key: "2-1",
        title: "mouse.menu.boardConfig",
        path: "boardConfig",
        icon: "boardconfig",
        modal: true,
        menuType: "mouse",
      },
    ],
  },
  {
    key: "3",
    title: "common.advancedConfig",
    children: [
      {
        key: "3-1",
        title: "mouse.menu.changeKey",
        path: "changeKey",
        icon: "changekey",
      },
      {
        key: "3-2",
        title: "mouse.menu.dpiSetting",
        path: "dpiSetting",
        icon: "dpi",
      },
      {
        key: "3-3",
        title: "mouse.menu.performance",
        path: "performance",
        icon: "performance",
      },
      {
        key: "3-4",
        title: "mouse.menu.macro",
        path: "macro",
        icon: "macro",
      },
      {
        key: "3-5",
        title: "mouse.menu.parameter",
        path: "parameter",
        icon: "parameter",
      },
      {
        key: "3-6",
        title: "mouse.menu.lighting",
        path: "lighting",
        icon: "light",
      },
      {
        key: "3-7",
        title: "mouse.menu.other",
        path: "other",
        icon: "other",
      },
    ],
  },
];

// 鼠标菜单默认使用匠盟配置（与键盘根据 solutionRovider 切换一致，由使用方按设备切换）
export const mouseMenuData = mouseMenuDataJiangMeng;

// 默认导出键盘菜单（保持向后兼容）
const menuData = keyboardMenuData;
export default menuData;
